export default "__VITE_ASSET__Cn7Q6MBM__"